import React from 'react';
import "./InfluencerInvite.scss";
import { Container } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

const InfluencerInvite = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    return (
        <div className="influencer_invite_page">
            <Container>
                <div className="page_in">
                    <h2>Congratulations !! Your Auction is Scheduled </h2>
                    {/* <div className="page_content">
                        <p><b>Boost this auction success!</b> Invite influencers to join and amplify your reach. The more people talking about this auction, the better your odds. Share your auction now and make waves with the power of influence.</p>
                        <p>Payment to influencers is solely success based on auction results—so it's a win-win!</p>
                        <p>Share your auction now and let the power of influence work for you.</p>
                    </div>
                    <p><b>Once the auction is approved, you can invite influencers from My Listings.</b></p> */}
                    <div className="action_box">
                        {/* <button type="button" className='custom_btn' onClick={() => navigate('/influncer-auction-list', { state: state })}>Invite Influencers to This Auction</button> */}
                        <button type="button" className='custom_btn' onClick={() => navigate('/dashboard')}>Back to My Listing</button>
                    </div>
                </div>
            </Container>
        </div>
    );
};

export default InfluencerInvite;
